// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-toggle-container {
    position: relative;
    border: 2px solid #007bff;
    border-radius: 50px;
    overflow: hidden;
    background-color: #f8f9fa;
    width: 320px;
    height: 50px;
}

.custom-toggle-button {
    flex: 1 1;
    border: none;
    background: none;
    color: #007bff;
    font-weight: 600;
    font-size: 16px;
    z-index: 2;
    cursor: pointer;
    transition: color 0.3s ease;
}

.custom-toggle-button:hover {
    color: #0056b3;
}

.custom-toggle-button.active {
    color: white;
}

.custom-toggle-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    background-color: #007bff;
    border-radius: 50px;
    transition: left 0.3s ease;
    z-index: 1;
}

.custom-toggle-slider.image {
    left: 0;
}

.custom-toggle-slider.video {
    left: 50%;
}

.custom-modal {
    animation: fadeIn 0.3s ease-out;
    backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.8);
}

@keyframes fadeIn {
    from {
        background-color: rgba(0, 0, 0, 0);
        opacity: 0;
    }

    to {
        background-color: rgba(0, 0, 0, 0.8);
        opacity: 1;
    }
}

.modal-nav-button {
    font-size: 24px;
    background: linear-gradient(145deg, #2d2d2d, #1a1a1a);
    color: #fff;
    border: 2px solid #444;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    transition: all 0.2s ease;
}

.modal-nav-button:hover {
    background: linear-gradient(145deg, #1f1f1f, #0f0f0f);
    color: #3498db;
}

.modal-close-button {
    font-size: 32px;
    background: none;
    color: #fff;
    border: none;
    cursor: pointer;
    transition: color 0.2s;
}

.modal-close-button:hover {
    color: #ff4d4f;
}

.pres-images-scroll {
    max-height: 640px;
    overflow-y: auto;
    padding-right: 6px;
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/historique.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI;QACI,kCAAkC;QAClC,UAAU;IACd;;IAEA;QACI,oCAAoC;QACpC,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".custom-toggle-container {\n    position: relative;\n    border: 2px solid #007bff;\n    border-radius: 50px;\n    overflow: hidden;\n    background-color: #f8f9fa;\n    width: 320px;\n    height: 50px;\n}\n\n.custom-toggle-button {\n    flex: 1;\n    border: none;\n    background: none;\n    color: #007bff;\n    font-weight: 600;\n    font-size: 16px;\n    z-index: 2;\n    cursor: pointer;\n    transition: color 0.3s ease;\n}\n\n.custom-toggle-button:hover {\n    color: #0056b3;\n}\n\n.custom-toggle-button.active {\n    color: white;\n}\n\n.custom-toggle-slider {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 50%;\n    background-color: #007bff;\n    border-radius: 50px;\n    transition: left 0.3s ease;\n    z-index: 1;\n}\n\n.custom-toggle-slider.image {\n    left: 0;\n}\n\n.custom-toggle-slider.video {\n    left: 50%;\n}\n\n.custom-modal {\n    animation: fadeIn 0.3s ease-out;\n    backdrop-filter: blur(6px);\n    background-color: rgba(0, 0, 0, 0.8);\n}\n\n@keyframes fadeIn {\n    from {\n        background-color: rgba(0, 0, 0, 0);\n        opacity: 0;\n    }\n\n    to {\n        background-color: rgba(0, 0, 0, 0.8);\n        opacity: 1;\n    }\n}\n\n.modal-nav-button {\n    font-size: 24px;\n    background: linear-gradient(145deg, #2d2d2d, #1a1a1a);\n    color: #fff;\n    border: 2px solid #444;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);\n    transition: all 0.2s ease;\n}\n\n.modal-nav-button:hover {\n    background: linear-gradient(145deg, #1f1f1f, #0f0f0f);\n    color: #3498db;\n}\n\n.modal-close-button {\n    font-size: 32px;\n    background: none;\n    color: #fff;\n    border: none;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.modal-close-button:hover {\n    color: #ff4d4f;\n}\n\n.pres-images-scroll {\n    max-height: 640px;\n    overflow-y: auto;\n    padding-right: 6px;\n    overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
